import React from "react";
import { db } from "../firebase/firebase";
import { useState, useContext, useEffect, createContext } from "react";
import { Authcontext } from "./Authcontext";
import { useHistory } from "react-router-dom";
export const BookContext = createContext();
const BookContextProvider = (props) => {
  const [lentDetails, setLentDetails] = useState(false);
  const [BookList, setBookList] = useState([]);
  const [details, setDetails] = useState(null);
  const [Loading, setLoading] = useState(false);
  
  let history = useHistory()
  

  const addBook = (bookDetails) => {
    console.log("add book");
    db.collection("bookshelf")
      .add({
        name: bookDetails.name,
        author: bookDetails.author,
        price: bookDetails.price,
        date: bookDetails.date,
        read: bookDetails.read,
        user: bookDetails.user,
        lent: false,
      })
      .then((res) => console.log(res))
      .catch((e) => {console.log(e)
      history.push("/error")});
  };
  const displayBookList = (User) => {
    setLoading(true);
  
    console.log(User)
    db.collection("bookshelf").where('user', '==', User)
      .onSnapshot(((results) => {
        console.log("inside dispbukfnc")
        const list = [];
        results.docs.map((item) => {
          list.push(item);
          console.log(item.data());
        });
        console.log(list);
        setBookList(list);
        setLoading(false);
      }));
  };
  const getDetails = (id) => {
    setDetails(null);
    setLoading(true);
    console.log(id);
    db.collection("bookshelf")
      .doc(id)
      .onSnapshot((result) => {
        console.log("inside getdetails");
        console.log(result.data());
        setDetails(result.data());
        setLoading(false);

      });
  };
  const getLentDetails = (id) => {
    setLoading(true);
    console.log(id);
    db.collection("lend")
      .doc(id)
      .onSnapshot((result) => {
        console.log(result.data());
        setLentDetails({ ...result.data() });
      });
    setLoading(false);
  };
  const markRead = (id) => {
    setLoading(true);
    db.collection("bookshelf").doc(id).update({ read: "true" });
    setLoading(false);
  };
  const lendBook = (id, details) => {
    console.log("lendbook");
    console.log(details);

    db.collection("lend")
      .doc(id)
      .set({
        name: details.name,
        date: details.date,
      })
      .then((res) => {
        db.collection("bookshelf")
          .doc(id)
          .update({ lent: "true" })
          .then((res) => console.log("updated"))
          .catch((e) => {console.log(e)
            history.push("/error")});
      })
      .catch((e) => {console.log(e)
        history.push("/error")});
  };
  const unLend = (id) => {
    db.collection("bookshelf").doc(id).update({ lent: false });
  };
const sortBooks =(option, User)=>{
    setLoading(true);
    if(option == "lent"){
    db.collection("bookshelf")
      .where('lent', '==','true').where('user', '==', User)
      .onSnapshot((results) => {
        const list = [];
        results.docs.map((item) => {
          list.push(item);
          console.log(item.data());
        });
        console.log(list);
        setBookList(list);
        setLoading(false);
      });}
      if(option == "unread"){
        db.collection("bookshelf")
          .where('read', '==',false).where('user', '==', User)
          .onSnapshot((results) => {
            const list = [];
            results.docs.map((item) => {
              list.push(item);
              console.log(item.data());
            });
            console.log(list);
            setBookList(list);
            setLoading(false);
          });}
          if(option == "unlent"){
            db.collection("bookshelf")
              .where("lent", "==",false).where('user', '==', User)
              .onSnapshot((results) => {
                const list = [];
                results.docs.map((item) => {
                  list.push(item);
                  console.log(item.data());
                });
                console.log(list);
                setBookList(list);
                setLoading(false);
              });}
              if(option == "read"){
                db.collection("bookshelf")
                  .where("read", "==","true").where('user', '==', User)
                  .onSnapshot((results) => {
                    const list = [];
                    results.docs.map((item) => {
                      list.push(item);
                      console.log(item.data());
                    });
                    console.log(list);
                    setBookList(list);
                    setLoading(false);
                  });}
}
  return (
    <div>
      <BookContext.Provider
        value={{
          addBook,
          markRead,
          displayBookList,
          BookList,
          getDetails,
          details,
          Loading,
          lendBook,
          unLend,
          getLentDetails,
          lentDetails,
          sortBooks
        }}
      >
        {props.children}
      </BookContext.Provider>
    </div>
  );
};
export default BookContextProvider;
